import { useQuery } from '@tanstack/react-query';
import appointmentServices from '../services/appointment.service';

export const useAppointment = (id) => {
  return useQuery({
    queryKey: ['appointment', id],
    queryFn: () =>
      appointmentServices.getAppointmentById(id),
    enabled: !!id, // prevents firing when id is undefined
    staleTime: 30 * 1000,
  });
};